import { Anchor, Ship, ShieldCheck, Globe2, Users, Waves } from "lucide-react";
import { LegalPage, LegalSection } from "@/components/LegalPage";
import { COMPANY } from "@/lib/company";

export default function About() {
  const stats = [
    { icon: Anchor, value: "60+", label: "Ports connected" },
    { icon: Ship, value: "100+", label: "Routes & sailings" },
    { icon: Users, value: "24/7", label: "Traveller support" },
    { icon: Globe2, value: "5–7 days", label: "Refund turnaround" },
  ];
  return (
    <LegalPage overline="Our story" title="About WaveLine" testid="about-page">
      <LegalSection>
        <p>
          {COMPANY.brand} is a modern ferry &amp; coastal cruise booking platform built and operated by{" "}
          <strong>{COMPANY.legal}</strong>. Our mission is simple: make sailing India's coast, harbours,
          backwaters and islands as easy as booking a cab — with transparent fares, reliable schedules and
          instant e-tickets.
        </p>
      </LegalSection>

      <div className="grid grid-cols-2 sm:grid-cols-4 gap-4">
        {stats.map((s) => (
          <div key={s.label} className="bg-white border border-border rounded-xl p-5" data-testid={`about-stat-${s.label}`}>
            <s.icon className="h-5 w-5 text-accent mb-3" strokeWidth={1.75} />
            <div className="font-display font-bold text-2xl text-primary">{s.value}</div>
            <div className="text-xs text-muted-foreground mt-0.5">{s.label}</div>
          </div>
        ))}
      </div>

      <LegalSection heading="What we do">
        <p>From the daily Mumbai–Mandwa RoPax to Andaman island hops, Kerala backwater crossings and premium cruises to Goa and Lakshadweep, we bring operators and travellers together in one seamless booking experience.</p>
      </LegalSection>

      <LegalSection heading="Why travellers choose us">
        <ul className="space-y-2">
          <li className="flex gap-2"><ShieldCheck className="h-5 w-5 text-accent shrink-0" /> Secure, encrypted payments and instant confirmation.</li>
          <li className="flex gap-2"><Waves className="h-5 w-5 text-accent shrink-0" /> Accurate, live schedules across every operator we list.</li>
          <li className="flex gap-2"><Users className="h-5 w-5 text-accent shrink-0" /> Friendly support and a transparent refund policy.</li>
        </ul>
      </LegalSection>

      <LegalSection heading="The company behind WaveLine">
        <p><strong>{COMPANY.legal}</strong> is a technology company based in {COMPANY.address}, focused on building reliable travel and mobility products for the Indian coastline.</p>
      </LegalSection>
    </LegalPage>
  );
}
